import { jsx as c } from "react/jsx-runtime";
import { c as i } from "../../../clsx-OuTLNxxd.js";
import { s } from "../../../columns.module-Du2wMSpT.js";
function p({ children: r, className: e = "", reverseOnMobile: m = !1, alignItems: o, ...l }) {
  const t = i(
    s.columns,
    m && s["reverse-on-mobile"],
    o && s[`align-items-${o}`],
    e
  );
  return /* @__PURE__ */ c("div", { className: t, ...l, children: r });
}
export {
  p as Columns
};
